import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { screenInfoFor } from "./screenTitles";

// abaixo de 768px (breakpoint md do Bootstrap) o menu vira gaveta por cima do conteúdo (ver
// .nt-sidebar em bootstrap-theme.css) — nesse modo fecha sozinho ao navegar, senão fica cobrindo a
// tela depois do clique. No desktop o menu empurra o conteúdo e só recolhe pelo botão.
function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia("(max-width: 767.98px)").matches);
  useEffect(() => {
    const mql = window.matchMedia("(max-width: 767.98px)");
    const onChange = () => setIsMobile(mql.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);
  return isMobile;
}

const SIDEBAR_KEY = "sp.sidebarOpen";

export function AppShell() {
  const location = useLocation();
  const { title, subtitle, group } = screenInfoFor(location.pathname);
  const isMobile = useIsMobile();
  const [drawerOpen, setDrawerOpen] = useState(false);
  // desktop: o botão de menu recolhe/mostra a barra lateral; a escolha fica salva no navegador.
  const [desktopOpen, setDesktopOpen] = useState(() => {
    try {
      return localStorage.getItem(SIDEBAR_KEY) !== "0";
    } catch {
      return true;
    }
  });

  useEffect(() => {
    setDrawerOpen(false);
  }, [location.pathname, isMobile]);

  function toggleSidebar() {
    if (isMobile) return setDrawerOpen((v) => !v);
    setDesktopOpen((v) => {
      try {
        localStorage.setItem(SIDEBAR_KEY, v ? "0" : "1");
      } catch {
        /* sem storage: só não lembra a escolha */
      }
      return !v;
    });
  }

  const sidebarClass = isMobile ? (drawerOpen ? "open" : "") : desktopOpen ? "" : "collapsed";

  return (
    <div className="nt-app">
      <Sidebar className={sidebarClass} onClose={() => setDrawerOpen(false)} />
      {isMobile && drawerOpen && <div className="nt-backdrop" onClick={() => setDrawerOpen(false)} />}
      <div className="nt-main">
        <Topbar group={group} title={title} onToggleSidebar={toggleSidebar} />
        <main className="nt-content">
          <div className="nt-wrap">
            <div className="nt-page-head">
              <h1>{title}</h1>
              {subtitle && <p>{subtitle}</p>}
            </div>
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
